module.exports = __webpack_public_path__ + "xcx.png?2027543a768dcf9aed6082f139acc713";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xcx.png
// module id = 660
// module chunks = 0